/**
 * Every screen that downloads when first opened (React Router `lazy`). After the first screen shows, the
 * rest are fetched in the background (`prefetchPages`), so moving between tabs doesn't wait for a download.
 */
export const PAGES = {
  customer: () => import("@/features/customers/CustomerPage"),
  customers: () => import("@/features/customers/CustomersPage"),
  dishes: () => import("@/features/dishes/DishesPage"),
  dispatch: () => import("@/features/dispatch/DispatchPage"),
  menus: () => import("@/features/menus/MenusPage"),
  template: () => import("@/features/menus/TemplatePage"),
  templates: () => import("@/features/menus/TemplatesPage"),
  money: () => import("@/features/money/MoneyPage"),
  payout: () => import("@/features/money/PayoutPage"),
  plan: () => import("@/features/plans/PlanPage"),
  plans: () => import("@/features/plans/PlansPage"),
  promoCodes: () => import("@/features/promo-codes/PromoCodesPage"),
  reports: () => import("@/features/reports/ReportsPage"),
  reviews: () => import("@/features/reviews/ReviewsPage"),
  settings: () => import("@/features/settings/SettingsPage"),
  subscription: () => import("@/features/subscriptions/SubscriptionPage"),
  subscriptions: () => import("@/features/subscriptions/SubscriptionsPage"),
  team: () => import("@/features/team/TeamPage"),
} as const;

/** Fetches every screen's code while the browser is idle (once; later calls reuse the same downloads). */
export function prefetchPages(): void {
  const load = () => Object.values(PAGES).forEach((page) => void page().catch(() => undefined));
  if ("requestIdleCallback" in window) window.requestIdleCallback(load, { timeout: 5_000 });
  else setTimeout(load, 2_000);
}
